export class HttpError extends Error {
  readonly status: number;
  readonly body: unknown;

  constructor(message: string, options: { status: number; body?: unknown; cause?: unknown }) {
    super(message, options.cause !== undefined ? { cause: options.cause } : undefined);
    this.name = "HttpError";
    this.status = options.status;
    this.body = options.body;
  }

  static fromUnknown(error: unknown, fallback = "Request failed"): HttpError {
    if (error instanceof HttpError) return error;

    if (error instanceof Error) {
      return new HttpError(error.message || fallback, { status: 0, cause: error });
    }

    return new HttpError(fallback, { status: 0, cause: error });
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}
